import { watch } from "vue";
import store from '@shared/store/index';
import { useUserAuth } from "../../private/imports/externalStoreData";

//Инициализация плеера
export const initAudioplayer = () => {
  const { hasPaidAccount } = useUserAuth();
  store.dispatch('Audioplayer/initPreviewPodcast');
  watch(hasPaidAccount,(newValue, oldValue) => {
    if (newValue && !oldValue) {
      store.dispatch('Audioplayer/initPlayer');
    } else if(!newValue){
    }}, { immediate: true }
  );
}